// OLD BASE SCHEMA
// export function getBaseSchema() {
//   return {
//     "@context": "https://schema.org",
//     "@type": "WebPage",
//     "name": "Empowering the Circular IT Industry Since 1999",
//     "url": "https://www.thebrokersite.com/",
//     "description": "Empowering the Circular IT Industry since 1999. The Broker Site is the leading B2B marketplace for the Circular IT Industry.",
//     "inLanguage": "English",
//     "isPartOf": {
//       "@type": "WebSite",
//       "name": "TheBrokerSite",
//       "url": "https://www.thebrokersite.com"
//     },
//     "publisher": {
//       "@type": "Organization",
//       "@id": "https://www.thebrokersite.com/#organization",
//       "name": "The Broker Site",
//       "legalName": "The Broker Site BV",
//       "url": "https://www.thebrokersite.com",
//       "description": "The B2B marketplace for the Circular IT Industry. The Broker Site connects IT traders, brokers, ITADs, refurbishers, resellers and wholesalers worldwide.",
//       "foundingDate": "1999-08-01",
//       "telephone": "+31 621546725",
//       "address": {
//         "@type": "PostalAddress",
//         "streetAddress": "Ginnekenweg 272",
//         "postalCode": "4835 NK",
//         "addressLocality": "Breda",
//         "addressCountry": "NL"
//       },
//       "contactPoint": {
//         "@type": "ContactPoint",
//         "telephone": "+31 621546725",
//         "contactType": "customer service",
//         "areaServed": "Worldwide",
//         "availableLanguage": ["English"],
//         "url": "https://www.thebrokersite.com/contact"
//       },
//       "areaServed": {
//         "@type": "Place",
//         "name": "Worldwide"
//       },
//       "logo": {
//         "@type": "ImageObject",
//         "url": "https://www.thebrokersite.com/media/img/tbs_logo.png"
//       },
//       "sameAs": [
//         "https://www.linkedin.com/company/the-broker-site/",
//         "https://twitter.com/TheBrokerSite",
//         "https://www.facebook.com/thebrokersite",
//         "https://www.youtube.com/thebrokersite"
//       ]
//     }
//   };
// }

// NEW BASE SCHEMA

export function getBaseSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": "https://www.thebrokersite.com/#webpage",
    "name": "Empowering the Circular IT Industry Since 1999",
    "url": "https://www.thebrokersite.com/",
    "description":
      "The Broker Site is the B2B marketplace for IT traders, brokers, ITADs, refurbishers, resellers and wholesalers buying and selling new, used and refurbished computers, laptops, servers, mobiles, parts and other IT equipment worldwide.",
    "inLanguage": "en",

    "isPartOf": {
      "@type": "WebSite",
      "@id": "https://www.thebrokersite.com/#website",
      "name": "The Broker Site",
      "url": "https://www.thebrokersite.com/",
      "publisher": {
        "@id": "https://www.thebrokersite.com/#organization"
      }
    },

    "publisher": {
      "@type": "Organization",
      "@id": "https://www.thebrokersite.com/#organization",
      "name": "The Broker Site",
      "legalName": "The Broker Site BV",
      "url": "https://www.thebrokersite.com/",
      "description":
        "The Broker Site is a worldwide B2B marketplace connecting IT traders, brokers, ITADs, refurbishers, resellers and wholesalers to buy and sell new, used and refurbished computers, laptops, servers, mobiles, parts and other IT equipment.",
      "foundingDate": "1999-08-01",

      "logo": {
        "@type": "ImageObject",
        "@id": "https://www.thebrokersite.com/#logo",
        "url": "https://www.thebrokersite.com/media/img/tbs_logo.png"
      },

      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Ginnekenweg 272",
        "postalCode": "4835 NK",
        "addressLocality": "Breda",
        "addressCountry": "NL"
      },

      "telephone": "+31621546725",

      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+31621546725",
        "contactType": "customer service",
        "areaServed": "Worldwide",
        "availableLanguage": ["en"],
        "url": "https://www.thebrokersite.com/contact"
      },

      "areaServed": "Worldwide",

      "sameAs": [
        "https://www.linkedin.com/company/the-broker-site/",
        "https://twitter.com/TheBrokerSite",
        "https://www.facebook.com/thebrokersite",
        "https://www.youtube.com/thebrokersite"
      ]
    }
  };
}

export function useSchemaOrg(schema) {
    const schemaId = 'schema-org-script';
    const existingScript = document.getElementById(schemaId);
    if (existingScript) {
      existingScript.remove();
    }

    const baseSchema = getBaseSchema();
    
    // Merge the schemas correctly
    const mergedSchema = {
        ...baseSchema,
        ...schema
    };


    const script = document.createElement('script');
    script.id = schemaId; 
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(mergedSchema); // Fixed the JSON.stringify
    document.head.appendChild(script);
}